import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const Dummy = (props) => {
    const { now, id } = props;
    let content = "";
    if (id === "home")
        content = (now === "/" || now === "/home") ? "-" : "";
    if (id === "works")
        content = (now === "/works" ? "-" : "");
    if (id === "publication")
        content = (now === "/publication" ? "-" : "");
    if (id === "contact")
        content = (now === "/contact" ? "-" : "");
    return (<span className="dummy">{content}</span>)
}

const HeaderTop = (props) => {
    const { lang, openMenu, changeOpenMenu, scrollTop } = props;
    return (
        <div className={"header-top " + (lang === "jp" ? "header-top-ja" : "header-top-en")}>
            <div className="trigger-wrapper" style={{ position: "absolute" }} onClick={() => changeOpenMenu(!openMenu)}>
                <span className={"menu-trigger " + (openMenu ? "active" : "")} >
                    <span />
                    <span />
                    <span />
                </span>
            </div>
            <div className={"mobile-title " + ((!openMenu && scrollTop > 0) ? "disable" : "")}>
                <div className="lab">YUKI BAN</div>
            </div>
        </div>
    );
}

export const MobileHeader = (props) => {
    const { scrollTop, openMenu, changeOpenMenu, lang, changeLang } = props;
    const [now, setNow] = useState("");

    useEffect(() => {
        setNow(window.location.pathname);
    }, []);

    const navigate = useNavigate();

    const jumpRoute = (link) => {
        setNow(link);
        changeOpenMenu(false);
        navigate(link);
        console.log(link);
    };

    const jumpLang = (ln) => {
        changeLang(ln);
        changeOpenMenu(false);
    };

    const nowEvent = openMenu ? {} : { pointerEvents: "none" };


    return (
        <div style={nowEvent} className={"mobile-header " + (scrollTop === 0 ? "" : "small-header")} id="header">
            <div className="mobile-header-content" >
                <HeaderTop lang={lang} openMenu={openMenu} changeOpenMenu={changeOpenMenu} scrollTop={scrollTop} />
                <div className={"mobile-menu-block " + (!openMenu ? "disable" : "")}>
                    <div className="menu-wrapper">
                        <div className={(now === "/" || now === "/home") ? "selected-menu" : ""} onClick={() => { jumpRoute("/home") }}><Dummy id="home" now={now} />Home<Dummy id="home" now={now} /></div>
                        <div className={now === "/works" ? "selected-menu" : ""} onClick={() => { jumpRoute("/works") }}><Dummy id="works" now={now} />Works<Dummy id="works" now={now} /></div>
                        <div className={now === "/publication" ? "selected-menu" : ""} onClick={() => { jumpRoute("/publication") }}><Dummy id="publication" now={now} />Publication<Dummy id="publication" now={now} /></div>
                        <div className={now === "/contact" ? "selected-menu" : ""} onClick={() => { jumpRoute("/contact") }}><Dummy id="contact" now={now} />Contact<Dummy id="contact" now={now} /></div>
                        <div className="lang-block">
                            <div className={lang === "jp" ? "selected-lang" : ""} onClick={() => { jumpLang("jp") }}>日本語</div>
                            <div className={lang === "en" ? "selected-lang" : ""} onClick={() => { jumpLang("en") }}>English</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

//<div className={"header-back " + (openMenu ? "active-header-back" : "")} onClick={() => changeOpenMenu(false)} />
